<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="600px"
              scrollable
              z-index="210"
    >
        <v-card>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                    Create Company
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px;" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="py-4">
                <form>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.name"
                                v-validate="'required|min:1'"
                                :error-messages="errors.collect('form.name')"
                                label="Name"
                                data-vv-name="form.name"
                                data-vv-as="Name"
                                required
                            ></v-text-field>
                        </v-col>
                    
                    
                        <v-col col="6">
                            <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    label="Domain"
                                    v-validate="''"
                                    v-model="form.domain"
                                    :error-messages="errors.collect('form.domain')"
                                    data-vv-name="form.domain"
                                    data-vv-as="Domain"
                                    placeholder="Domain: e.g. example.com"
                            ></v-text-field>
                        </v-col>
                        <v-col col="6">
                            <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    label="Phone"
                                    v-validate="''"
                                    v-model="form.phone"
                                    :error-messages="errors.collect('form.phone')"
                                    data-vv-name="form.phone"
                                    data-vv-as="Phone"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                    v-model="form.categories"
                                    v-if="isAdmin()"
                                    :items="categories"
                                    label="Categories"
                                    multiple
                                    outlined
                                    chips
                                    clearable
                                    hide-details
                                    item-text="name"
                                    return-object
                                    small-chips
                                    deletable-chips
                                    data-vv-name="form.categories"
                                    data-vv-as="Categories"
                                    no-data-text="No categories found"
                              ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                v-model="form.logo"
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="Select image"
                                label="Company Logo"
                                outlined
                                hide-details
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12" centered v-if="form.logo">
                            <v-img 
                                    :src="logoSrc"
                                    style="max-height: 200px; max-width: 200px; border-radius: 10px; margin:auto"
                                    class="grey darken-4"
                            ></v-img>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeDialog">Cancel</v-btn>
                <v-btn elevation="0" :disabled="!formValidated" color="primary" @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: "createCompanyDialog",
		data: () => ({
			dialog: false,
			form: {
				name: '',
				domain: '',
				phone: '',
                categories: [],
				logo: null,
			},
            categories: [],
		}),
		computed: {
			formValidated() {
				return Object.keys(this.fields).some(key => this.fields[key].validated)
					&& Object.keys(this.fields).some(key => this.fields[key].valid);
			},
            logoSrc() {
				if(!this.form.logo) {
					return '';
                }
				return URL.createObjectURL(this.form.logo);
            }
		},
		methods: {
			logoChanged(file) {
				this.url = URL.createObjectURL(file);
            },
			showDialog: function () {
                this.getCategories();
				this.dialog = true;
			},
			closeDialog: function () {
				this.dialog = false;
				this.clearForm();
				this.$emit('closed');
			},

            async getCategories() {
                await this.$http.get(`/company-categories`).then(response => {
                this.categories = response.data;
                });
            },

			async save() {
				if (await this.$formValidator.validate(this.form)) {
					try {
						let formData = new FormData();

						formData.append("logo", this.form.logo);
						formData.append("name", this.form.name);
						formData.append("domain", this.form.domain || '');
						formData.append("phone", this.form.phone || '');
                        let categories = this.form.categories.sort((a, b) => a.id - b.id);
                        for (var i = 0; i < categories.length; i++) {
                        formData.append("categories[]", categories[i].id);
                        }
						const response = await this.$http.post('/companies', formData, {
							headers: {
								"Content-Type": "multipart/form-data"
							}
						});
						this.$emit('created', response.data.data);
						this.closeDialog();
					} catch (e) {
                        console.log(e);
						this.$validationException(e)
					}
				}else {
                    console.log("Validation failed");
                    this.$notify.warning('Please fill all required fields', 'Validation Error', {
                        position: 'top-right',
                        duration: 3000,
                        icon: 'mdi-alert-circle-outline',
                    });
                }
			},
			clearForm () {
				this.form = {
					name: '',
					domain: '',
					phone: '',
                    categories: [],
				};
				this.url = '';
				this.$validator.reset();
			}
		},

	}
</script>

<style scoped>

</style>
